import React from "react";
import classNames from "classnames";
import * as c from "./landingPages.module.scss";
import Layout from "@components/layout";
import { BusinessPageHeader } from "@components/pages/landingPages/businessPage/businessPageHeader";
import MedIntegrationSection from "@components/pages/landingPages/businessPage/medIntegrationSection";
import { getLandingPageSections } from "@templates/landingPages/landingPageSections";

const BusinessPage = ({ contentfulLandingPage }) => {
  const { pageHeader, actionSections, sections, slug } = contentfulLandingPage;
  const { sectionComponents, actionSectionsComponents } = getLandingPageSections({
    sections,
    actionSections,
    className: c,
  });
  const showMedIntegrationSection = slug === "medical-spa-software" || slug === "iv-therapy-software";

  return (
    <Layout
      navColorVariant={pageHeader?.darkBackground ? "cream-100" : pageHeader?.backgroundColor?.value || "default"}
      className={classNames(c.pageWrapper, "cream-100")}
    >
      <BusinessPageHeader pageHeaderData={pageHeader} />

      <div className={c.sections}>
        {sectionComponents}

        {showMedIntegrationSection && <MedIntegrationSection />}

        {actionSectionsComponents}
      </div>
    </Layout>
  );
};

export default BusinessPage;
